import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function QuickEntry() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {categories.map((cat, i) => (
        <Link
          key={cat.key}
          to={cat.path}
          className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          style={{ animationDelay: `${i * 60}ms` }}
        >
          <span className="w-12 h-12 md:w-14 md:h-14 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className={`${cat.icon} text-2xl`} />
          </span>
          <div className="min-w-0">
            <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
              {cat.name}
            </h3>
            <p className="mt-1 text-xs md:text-sm text-foreground-500 truncate">{cat.tagline}</p>
          </div>
          <i className="ri-arrow-right-line ml-auto text-foreground-300 group-hover:text-primary-500 transition-colors" />
        </Link>
      ))}
    </div>
  );
}